export enum SCREEN {
  EXTRA_SMALL = 475,
  SMALL = 768,
  MEDIUM = 991,
  MEDIUM_LARGE = 1200,
  LARGE = 1440,
  LARGE_PLUS = 1550,
  EXTRA_LARGE = 1921,
}
